<template>
  <two-sides-modal
    v-model="isDialogOpen"
    title="Histórico Estado de cuenta"
    subtitle="Histórico Estado de cuenta"
    icon="mdi-archive-arrow-down-outline"
    height="auto"
  >
    <v-row>
      <v-col cols="12" md="12">
        <v-row class="mt-5">
          <v-col cols="12" md="9">
            <date-range-selector
              :min-date="minDate"
              :max-date="maxDate"
              @onClick="getHistoryByDate"
              @onReset="resetRange"
            />
          </v-col>
          <v-col cols="12" md="2">
            <v-btn
              class="red-button"
              width="auto"
              :disabled="downloading"
              @click="generatePDF"
            >
              {{ !downloading ? 'Exportar PDF' : 'Exportando PDF...' }}
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="12">
        <v-row class="mt-0" justify="end">
          <v-col cols="12" md="4">
            <search-input v-model="searchAccounntStatus" />
          </v-col>
        </v-row>
        <v-col cols="12" md="12">
          <v-progress-linear
            :active="loadingOrderDeliveryTime"
            :indeterminate="loadingOrderDeliveryTime"
            top
            color="red accent-4"
          />
          <account-status-table
            :items="items"
            :search="searchAccounntStatus"
            :loading="loadIcon"
            @onPDFClick="getPDFXMLInvoice"
            @onAccuseClick="getAccuseImage"
          />
        </v-col>
      </v-col>
      <template slot="actions-append"> </template>
    </v-row>
  </two-sides-modal>
</template>
<script>
  import { mapGetters } from 'vuex';
  import moment from 'moment';
  import TwoSidesModal from '@/components/modals/TwoSidesModal.vue';
  import AccountStatusTable from '@/components/tables/AccountStatusTable.vue';
  import DateRangeSelector from '@/components/DateRangeSelector.vue';
  import SearchInput from '@/components/SearchInput.vue';
  import axios from '@/plugins/axios';
  import dateFormats from '@/core/constants/DateFormats';
  import saveFile from '@/mixins/saveFile';

  export default {
    name: 'AccountStatusCard',
    components: {
      TwoSidesModal,
      AccountStatusTable,
      DateRangeSelector,
      SearchInput,
    },
    mixins: [saveFile],
    props: {
      value: {
        type: Boolean,
        default: true,
      },
      customerCode: { type: [String, Number], required: true },
      customerGroup: { type: [String, Number], required: true },
    },
    data() {
      return {
        loadingOrderDeliveryTime: true,
        items: [],
        searchAccounntStatus: '',
        error: '',
        datacustumer: {
          KUNNR: '',
          NAME1: '',
          STCD1: '',
          SMTP_ADDR: '',
          TELF1: '',
        },
        startDate: moment().startOf('month').format(dateFormats.ISO_DATE),
        endDate: moment().format(dateFormats.ISO_DATE),
        minDate: moment().subtract(2, 'years').toDate(),
        maxDate: moment().endOf('year').toDate(),
        loadIcon: {
          load: false,
          invoice: '',
        },
        downloading: false,
      };
    },
    computed: {
      ...mapGetters({
        user: 'auth/user',
      }),
      isDialogOpen: {
        set(newVal) {
          this.$emit('input', newVal);
        },
        get() {
          return this.value;
        },
      },
    },
    watch: {
      customerCode: {
        immediate: true,
        handler(newVal) {
          if (newVal) {
            this.infoCustomer();
            this.accountStatus(this.startDate, this.endDate);
          }
        },
      },
      isDialogOpen(newVal) {
        if (newVal && this.customerCode) {
          this.infoCustomer();
          this.accountStatus(this.startDate, this.endDate);
        }
      },
    },
    mounted() {
      if (this.customerCode) {
        this.infoCustomer();
        this.$nextTick(function () {
          this.accountStatus(this.startDate, this.endDate);
        });
      }
    },
    methods: {
      getHistoryByDate({ startDate, endDate }) {
        this.startDate = startDate;
        this.endDate = endDate;

        this.accountStatus(startDate, endDate);
      },
      async accountStatus(startDate, endDate) {
        this.loadingOrderDeliveryTime = true;

        const params = {
          client: this.customerCode,
          date_start: startDate,
          date_end: endDate,
          group_customer: this.customerGroup,
        };
        try {
          const response = await axios.post('/AccountStatus', params);
          this.loadingOrderDeliveryTime = false;
          this.items = response.data;
        } catch (error) {
          this.error = 'No se pudo obtener el estado de cuenta';
        }
      },
      async infoCustomer() {
        const params = {
          customer: this.customerCode,
          VKORG: this.user.VKORG,
          VTWEG: this.user.VTWEG,
          VKBUR: this.user.VKBUR,
        };

        try {
          const response = await axios.post('/infoCustomer', params);
          this.datacustumer = response.data;
        } catch (error) {
          this.error = 'No se pudo obtener la información del cliente';
        }
      },
      async getPDFXMLInvoice(invoice, type) {
        const newWindow = window.open('', '_blank');

        const params = {
          invoice: invoice,
          type: type,
        };

        try {
          const response = await axios.post('/InvoicePDFXML', params);
          this.url = (response.data || '').trim();

          if (!this.url) {
            if (newWindow) newWindow.close();
            this.error = 'No se pudo obtener el archivo';
            return;
          }

          if (newWindow) {
            newWindow.location.href = this.url;
          } else {
            window.location.href = this.url;
          }
        } catch (error) {
          this.error = 'No se pudo obtener el estado de cuenta';
        }
      },
      async generatePDF() {
        this.downloading = true;

        const params = {
          client: this.customerCode,
          name: this.datacustumer.NAME1,
          rfc: this.datacustumer.STCD1,
          email: this.datacustumer.SMTP_ADDR,
          phone: this.datacustumer.TELF1,
          date_start: this.startDate,
          date_end: this.endDate,
        };

        try {
          const response = await axios.post('account-status/pdf', params, {
            responseType: 'blob',
          });
          this.saveFileToDevice(response.data, 'historico_cuenta', 'pdf');
        } catch (error) {
          this.$toast.error('No fue posible completar la descarga.');
        }

        this.downloading = false;
      },
      async getAccuseImage(invoice) {
        this.loadIcon = {
          load: true,
          invoice: invoice,
        };

        const params = {
          invoice: invoice,
        };

        try {
          const response = await axios.post('/getDocumentReceipt', params);
          const document = response.data.ACUSEDOC64;
          this.getImage64(document);
        } catch (error) {
          this.error = 'No se pudo obtener la información del Acuse';
        }

        this.loadIcon = {
          load: false,
          invoice: invoice,
        };
      },

      getImage64(base64Image) {
        const newWindow = window.open();
        const image = new Image();
        image.src = base64Image;
        image.onload = () => {
          newWindow.document.body.appendChild(image);
        };
      },
      resetRange() {
        this.range.startDate = null;
        this.range.endDate = moment().format(dateFormats.HTML_DATE);
      },
    },
  };
</script>
